<app-project-submenu></app-project-submenu>
<p-confirmdialog />
<app-new-bot-modal
  [(visible)]="showNewBotDialog"
  [templates]="templates"
/>
<p-dialog
  [(visible)]="importErrorDialogVisible"
  [modal]="true"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <i class="ri-error-warning-fill text-danger fs-4"></i>
      <span i18n="@@import-error-report-header">Import abgebrochen</span>
    </div>
  </ng-template>

  <p
    class="mb-3"
    i18n="@@import-error-report-message"
  >
    Der Import wurde vollständig zurückgedreht. Prüfe die Fehler und korrigiere die betroffenen Inhalte vor dem nächsten
    Versuch.
  </p>

  @if (importFailureMessage) {
  <div class="mb-3">
    <strong i18n="@@import-error-summary-label">Zusammenfassung:</strong>
    <div>{{ importFailureMessage }}</div>
  </div>
  }

  @if (importFailureReport; as report) {
  @if (report.errors.length) {
  <div>
    <h6 i18n="@@import-error-report-errors">Fehler</h6>
    <ul class="mb-3">
      @for (err of report.errors; track err) {
      <li>
        <span>{{ err.message }}</span>
        @if (err.itemName) {
        <span> ({{ err.itemName }})</span>
        }
      </li>
      }
    </ul>
  </div>
  }
  @if (report.cleanupWarnings.length) {
  <div>
    <h6 i18n="@@import-error-report-cleanup">Hinweise zur Bereinigung</h6>
    <ul class="mb-0">
      @for (warning of report.cleanupWarnings; track warning) {
      <li>
        {{ warning.scope }}: {{ warning.message }}
      </li>
      }
    </ul>
  </div>
  }
  }

  <ng-template #footer>
    <p-button
      (click)="importErrorDialogVisible = false"
      i18n-label="@@understood"
      label="Verstanden"
      severity="secondary"
    />
  </ng-template>
</p-dialog>
<p-dialog
  [(visible)]="duplicateErrorDialogVisible"
  [modal]="true"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <i class="ri-error-warning-fill text-danger fs-4"></i>
      <span i18n="@@duplicate-error-report-header">Duplizieren abgebrochen</span>
    </div>
  </ng-template>

  <p
    class="mb-3"
    i18n="@@duplicate-error-report-message"
  >
    Das Duplizieren wurde abgebrochen. Prüfe die Fehler und versuche es erneut.
  </p>

  @if (duplicateFailureReport; as report) {
  @if (report.errors.length) {
  <div>
    <h6 i18n="@@import-error-report-errors">Fehler</h6>
    <ul class="mb-3">
      @for (err of report.errors; track err) {
      <li>
        <span>{{ err.message }}</span>
        @if (err.itemName) {
        <span> ({{ err.itemName }})</span>
        }
      </li>
      }
    </ul>
  </div>
  }
  @if (report.cleanupWarnings.length) {
  <div>
    <h6 i18n="@@import-error-report-cleanup">Hinweise zur Bereinigung</h6>
    <ul class="mb-0">
      @for (warning of report.cleanupWarnings; track warning) {
      <li>{{ warning.scope }}: {{ warning.message }}</li>
      }
    </ul>
  </div>
  }
  }

  <ng-template #footer>
    <p-button
      (click)="duplicateErrorDialogVisible = false"
      i18n-label="@@understood"
      label="Verstanden"
      severity="secondary"
    />
  </ng-template>
</p-dialog>
<ng-template #newBtn>
  @if (VIEWMODE() === 'PROJECT') {
  <p-button
    label="Neuen Bot erstellen"
    i18n-label="@@create-bot-desc"
    icon="ri-add-line ri"
    styleClass="bot-primary-button"
    (click)="this.addBot()"
    [disabled]="!this.canChangeProject()"
  />
  <input
    #importInput
    type="file"
    accept=".zip"
    style="display:none"
    (change)="this.onImportFileSelected($event)"
  />
  <p-button
    severity="secondary"
    [loading]="isImporting"
    [disabled]="!this.canChangeProject() || isImporting"
    icon="ri-file-upload-fill ri"
    i18n-label="@@import-bot"
    label="Bot Importieren"
    styleClass="bot-secondary-button"
    (click)="importInput.click()"
  />
  }
</ng-template>

@if (bots().length > 0) {
<div class="bot-toolbar">
  <div class="bot-toolbar-actions"> <ng-container [ngTemplateOutlet]="newBtn" /> </div>
  <p-iconfield>
    <p-inputicon class="ri ri-search-line" />
    <input
      pInputText
      class="bot-search-input"
      #filterInput
      type="text"
      placeholder="Suchen..."
      i18n-placeholder="@@search-placeholder"
      aria-label="Bots suchen"
      i18n-aria-label="@@bot-table-search"
      [disabled]="bulkBusy"
      (input)="selectedBots = []; dt.filterGlobal(filterInput.value, 'contains')"
    />
  </p-iconfield>
</div>
}
@if (bulkFailedNames) {
<p
  class="bot-bulk-error"
  role="alert"
><span i18n="@@bot-bulk-failed">Aktion für folgende Bots fehlgeschlagen:</span> {{bulkFailedNames}}</p>
}
<p-table
  class="project-bots-table"
  #dt
  dataKey="_id"
  [(selection)]="selectedBots"
  [value]="bots()"
  sortField="updated"
  [sortOrder]="-1"
  [rowHover]="true"
  [globalFilterFields]="['name', 'creatorName', 'updator', 'usedIn.botName']"
  [tableStyle]="{ 'table-layout': 'fixed', 'width': '100%', 'min-width': '760px' }"
>
  <ng-template #header>
    <tr>
      <th class="bot-selection-cell"><p-tableheadercheckbox
          [disabled]="bulkBusy || !userCanEditBotConfig()"
          ariaLabel="Alle angezeigten Bots auswählen"
          i18n-ariaLabel="@@bot-select-all"
        /></th>
      <th class="bot-icon-cell"><span i18n="@@bot-table-icon">Icon</span></th>
      <th pSortableColumn="name"><ng-container i18n="@@name">Name</ng-container><p-sorticon field="name" /></th>
      <th pSortableColumn="creatorName"><ng-container i18n="@@owner">Eigentümer</ng-container><p-sorticon
          field="creatorName"
        /></th>
      <th pSortableColumn="updated"><ng-container i18n="@@last-change">Aktualisiert</ng-container><p-sorticon
          field="updated"
        /></th>
      <th class="bot-menu-cell"></th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-bot
  >
    <tr>
      <td class="bot-selection-cell"><p-tablecheckbox
          [value]="bot"
          [disabled]="bulkBusy || !canEditBot(bot)"
          [ariaLabel]="bot.name"
        /></td>
      <td class="bot-icon-cell"><app-bot-icon [botConfig]="bot" /></td>
      <td>
        <div class="bot-status">
          <a
            class="bot-name"
            [routerLink]="['/', 'bot-admin', bot._id, botService.getBotDeeplink(bot)]"
          >{{bot.name}}</a>
          @if (bot.isTemplate) { <p-tag
            icon="ri-layout-5-line"
            value="Template"
            i18n-value="@@template"
          /> }
          <app-admin-position-bubble [position]="bot._id" />
          @if (bot.writeProtected) {
          <app-hint
            [customIcon]="'ri-lock-fill'"
            [customColor]="'#666 !important'"
            i18n="@@bot-write-protected-hint"
          >Schreibgeschützt</app-hint>
          } @else if (!userCanEditBotConfig()) {
          <app-hint
            [customIcon]="'ri-lock-fill'"
            [customColor]="'#666 !important'"
            i18n="@@bot-no-edit"
          >Du kannst diesen Bot nicht bearbeiten</app-hint>
          }
          @if (bot.quarantine?.isQuarantined) {
          <app-hint
            [customIcon]="'ri-surgical-mask-line'"
            [customColor]="'red !important'"
            i18n="@@bot-quarantine"
          >Bot ist in Quarantäne</app-hint>
          }
        </div>
      </td>
      <td class="bot-metadata">{{bot.creatorName}}</td>
      <td class="bot-metadata">
        @if (bot.updated) {
        <a
          class="bot-updated"
          [routerLink]="['/', 'bot-admin', bot._id, 'changelog']"
          [title]="dayjs(bot.updated).format('DD.MM.YYYY HH:mm')"
        >{{dayjs(bot.updated).fromNow()}}</a>
        @if (bot.updator) { <span class="bot-updator">{{bot.updator}}</span> }
        } @else { — }
      </td>
      <td class="bot-menu-cell">
        <p-button
          [disabled]="bulkBusy"
          (onClick)="openMenu($event, menu, bot)"
          rounded
          severity="secondary"
          icon="ri ri-more-2-fill"
          styleClass="button-icon"
          ariaLabel="Bot-Aktionen"
          i18n-ariaLabel="@@bot-row-actions"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td
        colspan="6"
        class="text-center p-5 text-muted"
      >
        @if (this.bots().length === 0) {
        @if (VIEWMODE() ==='PROJECT') {
        <ng-container i18n="@@no-bots-yet">
          Noch keine Bots in diesem Projekt. Erstelle deinen ersten Bot.
        </ng-container>
        }
        }
        @if (this.bots().length > 0) {
        <ng-container i18n="@@no-bots-found">
          Keine Bots gefunden. Passe deine Suche an.
        </ng-container>
        }
        <br><br>
        <div class="text-center d-flex flex-column gap-2">
          <ng-container [ngTemplateOutlet]="newBtn"></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-menu
  #menu
  appendTo="body"
  [model]="contextMenu"
  [popup]="true"
/>
<app-bulk-action-bar
  [actions]="bulkActions"
  [count]="selectedBots.length"
  [busy]="bulkBusy"
  [allSelected]="selectedBots.length === (dt.filteredValue ?? bots()).length"
  (selectAll)="selectedBots = (dt.filteredValue ?? bots()).slice()"
  (clear)="selectedBots = []"
/>
